import type { FaireProductEntity } from "../../entity_types/product";

export const p_p4vxc2uheu: FaireProductEntity = {
  token: "p_p4vxc2uheu",
  type: "product",
  name: "Glass Candle w/ Bamboo Lid Best Mom Ever",
  brandToken: "b_3811aa80",
  brandName: "Christian Art Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/f1a5e9ead984b3b3847ddc439e54ca07a17d94f4e5d06d6e0a3b97247e00fa83.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description:
    'Pink label and white frame design, Pink glass jar, White text, Best Mom Ever, Fragrance: Fresh Air and Sea Salt, 100% essential oil fragrance, 8% fragrance grade, 100% soy wax, Single cotton wick, Safe, cruelty-free, paraben-free, and phthalate-free, Burn time: 50 hours, Bamboo lid with engraved sentiment, Packaged in a brown kraft paper tuck-top gift box, Capacity: 10 oz candle Size: 3.5" x 3" x 3" (89 x 76 x 76 mm)',
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:37.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
